import * as React from "react";
import { cn } from "../util";

export const Input = React.forwardRef<
  HTMLInputElement,
  React.InputHTMLAttributes<HTMLInputElement>
>(({ className, type = "text", ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      "flex h-10 w-full border border-input bg-fondo px-3 py-2 font-ui text-sm text-tinta placeholder:text-tinta-tenue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 file:border-0 file:bg-transparent file:font-semibold",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-24 w-full border border-input bg-fondo px-3 py-2 font-ui text-sm text-tinta placeholder:text-tinta-tenue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";

export function Etiqueta({ className, ...props }: React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={cn(
        "block font-ui text-xs font-semibold uppercase tracking-wide text-tinta-3",
        className,
      )}
      {...props}
    />
  );
}

/** Campo = etiqueta + control + ayuda/error, con el ritmo vertical de la marca. */
export function Campo({
  etiqueta,
  ayuda,
  error,
  htmlFor,
  children,
  className,
}: {
  etiqueta: string;
  ayuda?: string;
  error?: string;
  htmlFor?: string;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("space-y-1.5", className)}>
      <Etiqueta htmlFor={htmlFor}>{etiqueta}</Etiqueta>
      {children}
      {error ? (
        <p className="text-xs text-rojo">{error}</p>
      ) : ayuda ? (
        <p className="text-xs text-tinta-tenue">{ayuda}</p>
      ) : null}
    </div>
  );
}
